export default __webpack_public_path__ + "static/media/Rebel's Battleaxe.67da7ee7.jpg";